import { AddCriteriaData } from "../Components/addCriteria/data/AddCriteria.data";
import { DuplicateCriteriaData } from "../Components/duplicateCriteria/data/Duplicate.Data";
import { CriteriaListingData } from "../data/CriteriaListingData";


export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "channel": filterDropDownList("Channel"),
        "statusId": filterDropDownList("Requirement Section Status"),
    };

    const formFields = [...CriteriaListingData.formFields,...AddCriteriaData.formFields,...DuplicateCriteriaData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};